import React from "react";
import {Col, Row} from "react-bootstrap";
import {White} from "../../Constants/ColorChart";
import styled from "styled-components";

const LinkSpan = styled.span`
  text-alignment: center;
  padding: 20px 30px;
  a {
    color: ${White};
  }
`;

const LoginRegisterAndForgot: React.FC<{}> = () => {
    return (
        <Row>
            <Col
                lg={{span: 6, offset: 3}}
                xs={{span: 12, offset: 0}}
                style={{paddingBottom: 20, textAlign: "center"}}
            >
                {
                  process.env.REACT_APP_SEE_SELF_ENROLLMENT === '1' &&
                  <LinkSpan>
                    <a href="/new_user">Register</a>
                  </LinkSpan>
                }
                {
                  process.env.REACT_APP_SEE_PASSWORD_RESET === '1' &&
                  <LinkSpan>
                    <a href="/password_recovery">Forgot password or username?</a>
                  </LinkSpan>
                }
            </Col>
        </Row>
    );
}

export default LoginRegisterAndForgot;